import React from 'react'

import { prop } from 'ramda'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import NumberInput from '../../../../../packages/kiti/components/form/NumberInput.js'

import { UNIT } from '../_shared/constants.js'

const TimeQuantitySentence = () => {
  const form = useForm()
  const { handleChangeIn } = useFormState()

  const event = prop('event')(form)
  const configuration = prop('configuration')(form)

  if (!event.startsWith('relative_before') && !event.startsWith('relative_after')) return false

  return (
    <>
      <EditableSentence
        label={configuration?.value || '_____'}
        field="value"
        Input={NumberInput}
        value={configuration?.value}
        path={['configuration', 'value']}
        onChange={handleChangeIn(['configuration', 'value'])}
        disableCloseOnChange
        onlyInt
      />
      <EditableSentence
        label={configuration?.measure?.name || '_____'}
        field="measure"
        value={configuration?.measure}
        path={['configuration', 'measure']}
        onChange={handleChangeIn(['configuration', 'measure'])}
        options={UNIT}
      />
    </>
  )
}

export default TimeQuantitySentence
